import { LayoutHOC } from 'base/ui/layout/layout';
import ListGifts from './ListGifts';
import { exchangeRewardsRoutes } from './routes';
import manageRewardsPage from './Manage';
import createUpdatePage from './Manage/CreateUpdate';
import createUpdateGiftPage from './ListGifts/CreateUpdate';
import rewardsPage from './Manage/CreateUpdate/rewards';

export const createExchangeRewardsPage = (layoutHOC: LayoutHOC) => {

  // danh sách quà tặng
  const ListGiftsPage = ListGifts()
  const CreateGiftPage = createUpdateGiftPage()
  const UpdateGiftPage = createUpdateGiftPage()


  // ------------------------------------------------------------------------------------------------
  // quản lý đổi thưởng
  const ManageRewards = manageRewardsPage()
  // add quản lý đổi thưởng
  const AddManage = createUpdatePage()
  // detail and update quản lý đổi thưởng
  const UpdateManage = createUpdatePage()
  const Reward = rewardsPage()


  const ExchangeRewardsPage = layoutHOC(exchangeRewardsRoutes)

  return () => (
    <ExchangeRewardsPage
      ListGifts={ListGiftsPage}
      CreateGift={CreateGiftPage}
      UpdateGift={UpdateGiftPage}

      ManageExchangeRewards={ManageRewards}
      CreateManage={AddManage}
      UpdateManage={UpdateManage}
      Reward={Reward}
    />
  )
}